import React from 'react';
import { useSelector } from 'react-redux';
import { selectLocale } from './languageSlice';
import { IntlProvider } from 'react-intl';

export function Language(props) {
  const locale = useSelector(selectLocale);

  return (
    <IntlProvider
      locale={locale}
      key={locale}
      messages={props.messages[locale]}
    >
      {React.Children.only(props.children)}
    </IntlProvider>
  );
}
